export default "__VITE_ASSET__QPAUnXdi__"